export default __webpack_public_path__ + "static/media/position_status.e2c064be.svg";